var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCursor = function SvgCursor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.802 3.333h-13.25c-5.767 0-9.2 3.433-9.2 9.2v13.25c0 5.767 3.45 9.2 9.2 9.2h13.25c5.766 0 9.2-3.433 9.2-9.2v-13.25c0-5.767-3.45-9.2-9.2-9.2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m36.601 31.4-2.716.916c-.75.25-1.35.834-1.6 1.6l-.917 2.717c-.783 2.35-4.083 2.3-4.817-.05l-3.083-9.917c-.6-1.966 1.217-3.8 3.167-3.183l9.933 3.083c2.333.733 2.367 4.05.033 4.834Z",
    fill: "currentColor"
  })));
};
export default SvgCursor;